import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToWords } from 'to-words';
import { AdvertisementDetailsComponent } from '../pages/advertisement-details/advertisement-details.component';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-advt-credit-print',
  templateUrl: './advt-credit-print.component.html',
  styleUrl: './advt-credit-print.component.scss'
})
export class AdvtCreditPrintComponent implements OnInit {

  public globalId: string = '';
  totalinWords: string = '';
  toWords: any;
  credit_type: any;
  remark: any;
  name: any;
  add: any;
  mobile: any;
  invoicenum: any;
  invoicedate: any;
  CreitVC: any;
  jama: any;
  total_credit_amt: any;
  other_credit_amt: any;
  tds_amt: any;
  rcv_amt: any;
  invoice_no: any;
  invoice_date: any;
  voc_date:any;

  constructor(
    private dialogRef: MatDialogRef<AdvtCreditPrintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

  // If ID is passed, fetch data from API
  if (this.data && this.data.id) {
    this.globalId = this.data.id;
    this.fetchCreditNoteData();
    return;
  }

  // If full data object is passed (NOT id)
  if (this.data && Object.keys(this.data).length > 0) {
    this.populateDataFromDialog();
    return;
  }

  console.error("No ID or data received in dialog!");
}


  populateDataFromDialog(): void {
    this.name = this.data['name'];
    this.add = this.data['add'];
    this.mobile = this.data['mobile'];
    this.invoicenum = this.data['invoicenum'];
    this.invoicedate = this.data['invoicedate'];
    this.jama = this.data['jama'];
    this.credit_type = this.data['credit_type'];
    this.remark = this.data['remark'];
    this.CreitVC = this.data['cr_voucher'];
    this.total_credit_amt = this.data['total_credit_amt'];
    this.other_credit_amt = this.data['other_credit_amt'];
    this.rcv_amt = this.data['rcv_amt'];
    this.invoice_no = this.data['invoice_no'];
    this.invoice_date = this.data['invoice_date'];
    this.tds_amt = this.data['tds_amt'];
    this.voc_date = this.data['voc_date'];


    this.convertAmountToWords();
  }

  // fetchCreditNoteData(): void {
  //   // Assuming you have an ID to fetch specific credit note
  //   const requestBody = { id: "16" }; // You can pass this from data if needed

  //   this.service.getCreditNoteDetails(requestBody).subscribe({
  //     next: (response: any[]) => {
  //       if (response && response.length > 0) {
  //         const data = response[0];
          
  //         // Map API response to component properties
  //         this.name = data.name;
  //         this.add = this.formatAddress(data);
  //         this.mobile = data.mobile;
  //         this.invoicenum = data.invoice_no;
  //         this.invoicedate = data.invoice_date;
  //         this.jama = data.credit_amt;
  //         this.credit_type = data.credit_type;
  //         this.remark = data.credit_remark;
  //         this.CreitVC = data.credit_voc_no;
  //         this.total_credit_amt = this.calculateTotalCreditAmount(data);
  //         this.other_credit_amt = data.other_credit_amt;
  //         this.rcv_amt = data.rcv_amt;
  //         this.invoice_no = data.invoice_no;
  //         this.invoice_date = data.invoice_date;
  //         this.tds_amt = data.tds_amt;

  //         this.convertAmountToWords();
  //         this.cdr.detectChanges();
  //       }
  //     },
  //     error: (error) => {
  //       console.error('Error fetching credit note data:', error);
  //     }
  //   });
  // }


  fetchCreditNoteData(): void {

  const requestBody = { id: this.globalId };

  this.service.getCreditNoteDetails(requestBody).subscribe({
    next: (response: any[]) => {
      if (response && response.length > 0) {

        const data = response[0];

        this.name = data.name;
        this.add = this.formatAddress(data);
        this.mobile = data.mobile;
        this.invoicenum = data.invoice_no;
        this.invoicedate = data.invoice_date;

        this.jama = data.invoice_amt;   // your API name
        this.rcv_amt = data.rcv_amt;
        this.voc_date = data.voc_date;

        this.credit_type = data.credit_type;
        this.remark = data.credit_remark;
        this.CreitVC = data.credit_voc_no;

        this.total_credit_amt = data.total_credit_amt;
        this.other_credit_amt = data.other_credit_amt;
        this.tds_amt = data.tds_amt;

        this.invoice_no = data.invoice_no;
        this.invoice_date = data.invoice_date;

        this.convertAmountToWords();
        this.cdr.detectChanges();
      }
    },
    error: (error) => {
      console.error("Credit Note Fetch Error:", error);
    }
  });
}

  formatAddress(data: any): string {
    let address = data.address || '';
    if (data.district) address += `, ${data.district}`;
    if (data.state) address += `, ${data.state}`;
    if (data.pincode && data.pincode !== '0') address += ` - ${data.pincode}`;
    if (data.country) address += `, ${data.country}`;
    return address;
  }

  calculateTotalCreditAmount(data: any): number {
    // Calculate total credit amount based on credit type
    let total = 0;
    if (data.tds_amt) total += parseFloat(data.tds_amt);
    if (data.other_credit_amt) total += parseFloat(data.other_credit_amt);
    return total || parseFloat(data.credit_amt) || 0;
  }

  convertAmountToWords(): void {
    this.toWords = new ToWords();
    this.totalinWords = this.toWords.convert(this.total_credit_amt, {
      currency: true,
    });
  }
}